import _regeneratorRuntime from "/home/syntaxval/Documents/Work.2017/StellarFox/redshift/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
/**
 * Various tools.
 *
 * @module utils
 * @license Apache-2.0
 * @author drmats
 */

import { dependencies, description, homepage, license, name, version } from "../package.json";
import { quote, wrap } from "./string";
import { access } from "./struct";
import { isFunction, isObject, isString, toBool } from "./type";
export var devEnv = function devEnv() {
  var strict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return (isBrowser() && !strict ? handleException(function () {
    return Object.prototype.hasOwnProperty.call(sessionStorage, "dev");
  }, function () {
    return false;
  }) : false) || isString(access(getProcess(), ["env", "NODE_ENV"])) && access(getProcess(), ["env", "NODE_ENV"]) !== "production" || !isBrowser() && !isString(access(getProcess(), ["env", "NODE_ENV"]));
};
export var getLibConfig = function getLibConfig() {
  return {
    dependencies: dependencies,
    description: description,
    homepage: homepage,
    license: license,
    name: name,
    version: version
  };
};
export var getProcess = function getProcess() {
  return function (envvars) {
    return isObject(process) ? _objectSpread({}, process, {
      browser: toBool(process.browser),
      env: _objectSpread({}, process.env, envvars)
    }) : {
      browser: toBool(process.browser),
      env: envvars
    };
  }({
    NODE_ENV: handleException(function () {
      return process.env.NODE_ENV;
    }),
    BABEL_ENV: handleException(function () {
      return process.env.BABEL_ENV;
    })
  });
};
export var handleException = function handleException(fn) {
  var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  try {
    return fn();
  } catch (ex) {
    return isFunction(handler) ? handler(ex) : ex;
  }
};
export var handleRejection = function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(fn) {
    var handler,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            handler = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
            _context.prev = 1;
            _context.next = 4;
            return fn();

          case 4:
            return _context.abrupt("return", _context.sent);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);

            if (!isFunction(handler)) {
              _context.next = 15;
              break;
            }

            _context.next = 12;
            return handler(_context.t0);

          case 12:
            _context.t1 = _context.sent;
            _context.next = 16;
            break;

          case 15:
            _context.t1 = _context.t0;

          case 16:
            return _context.abrupt("return", _context.t1);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  }));

  return function handleRejection(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var isBrowser = function isBrowser() {
  return toBool(getProcess().browser);
};
export var rgb = function rgb(r, g, b) {
  return wrap([r, g, b].join(", "), "rgb(", ")");
};
export var rgba = function rgba(r, g, b, a) {
  return wrap([r, g, b, a].join(", "), "rgba(", ")");
};
export var timeUnit = Object.freeze({
  second: 1000,
  minute: 60000,
  hour: 3600000,
  day: 86400000,
  week: 604800000,
  month: 2629800000,
  quarter: 7889400000,
  year: 31557600000
});
export var to_ = function to_() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "_";
  return function (val) {
    console.log("".concat(name, " = ").concat(quote(typeof val, "[]")));
    handleException(function () {
      (window || self)[name] = val;
      console.log(val);
    }, function () {
      if (!isBrowser()) {
        var _eval = eval("require(\"repl\")"),
            repl = _eval.repl;

        repl.context[name] = val;
        console.log(val);
        repl.context.process.stdout.write(repl._prompt);
      }
    });
    return val;
  };
};
export var url = function url(x) {
  return wrap(quote(x), "url(", ")");
};